define.alias("shared/components/shared/social/instagram-modal/available-page", "media/components/shared/social/instagram-modal/available-page");